import { Context } from '@nuxt/types';
import axios from 'axios';
import { IRestrictionUpsertEvent } from '~/types/event-restriction';

export class RestrictionsService {
  context: Context;
  eventsUrl: string;

  constructor(context: Context) {
    this.context = context;
    this.eventsUrl = `${context.env.restrictionsServiceEndpoint}/api/v1/events`;
  }

  private getAuthHeader() {
    // @ts-ignore For some reason it does not know about the token property https://github.com/nuxt-community/auth-module/issues/1338
    const token = this.context.$auth.strategy?.token?.get();
    if (!token) {
      return {};
    }

    return { Authorization: token };
  }

  async getEvent(eventId: string) {
    try {
      const results = await axios.get(`${this.eventsUrl}/${eventId}`, {
        headers: {
          ...this.getAuthHeader(),
        },
      });
      return results.data;
    } catch (err) {
      throw err;
    }
  }

  async upsertEvent(event: IRestrictionUpsertEvent) {
    try {
      const { id, ...restOfEvent } = event;
      const url = id ? `${this.eventsUrl}/${id}` : this.eventsUrl;
      const results = await axios.post(url, restOfEvent, {
        headers: {
          ...this.getAuthHeader(),
        },
      });
      return results.data;
    } catch (err) {
      throw err;
    }
  }
}
